import React, { useContext, useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";

import { Can } from "../Can";
import { makeStyles } from "@material-ui/core/styles";
import { IconButton, Menu, Divider, Chip, Box, useMediaQuery } from "@material-ui/core";
import { 
    DeviceHubOutlined, 
    History, 
    MoreVert, 
    PictureAsPdf, 
    Replay, 
    SwapHorizOutlined,
    VolumeOff,
    VolumeUp,
    Delete 
} from "@material-ui/icons";
import MicOff from '@material-ui/icons/MicOff';
import { v4 as uuidv4 } from "uuid";

import { i18n } from "../../translate/i18n";
import api from "../../services/api";
// import TicketOptionsMenu from "../TicketOptionsMenu";
import ButtonWithSpinner from "../ButtonWithSpinner";
import toastError from "../../errors/toastError";
import usePlans from "../../hooks/usePlans";
import { AuthContext } from "../../context/Auth/AuthContext";
import { TicketsContext } from "../../context/Tickets/TicketsContext";
import Tooltip from '@material-ui/core/Tooltip';
import ConfirmationModal from "../ConfirmationModal";
import * as Yup from "yup";
import { Formik, Form } from "formik";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import TextField from '@material-ui/core/TextField';

import Button from '@material-ui/core/Button';
import TransferTicketModalCustom from "../TransferTicketModalCustom";
import AcceptTicketWithouSelectQueue from "../AcceptTicketWithoutQueueModal";

//icones
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import UndoIcon from '@material-ui/icons/Undo';

import ScheduleModal from "../ScheduleModal";
import MenuItem from "@material-ui/core/MenuItem";
import { Switch } from "@material-ui/core";
import ShowTicketOpen from "../ShowTicketOpenModal";
import { toast } from "react-toastify";
import useCompanySettings from "../../hooks/useSettings/companySettings";
import ShowTicketLogModal from "../ShowTicketLogModal";
import TicketMessagesDialog from "../TicketMessagesDialog";
import { useTheme } from "@material-ui/styles";
import TicketDetailsModal from "../TicketDetailsModal";


import Error from '@material-ui/icons/Error';
import VerifiedUser from '@material-ui/icons/VerifiedUser';



const useStyles = makeStyles(theme => ({
    // Layout responsivo principal
    actionBar: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end", // Alinhamento à direita
        gap: theme.spacing(0.5),
        padding: theme.spacing(0.5, 1),
        backgroundColor: "transparent", // Fundo totalmente transparente
        borderRadius: 0,
        boxShadow: "none", // Sem sombra
        width: "auto", // Ocupa apenas o necessário
        marginLeft: "auto", // Empurra para a direita
        flex: "0 0 auto", // Não cresce nem encolhe
        whiteSpace: "nowrap", // Mantém os ícones em uma linha
        [theme.breakpoints.down('sm')]: {
            gap: theme.spacing(0.5),
            padding: theme.spacing(0.5),
            width: '100%',
            marginLeft: 0,
            flex: '0 0 100%',
            justifyContent: 'center', // centraliza horizontalmente
        }
    },
    
    // Grupos de botões
    buttonGroup: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(0.5),
        [theme.breakpoints.down('sm')]: {
            gap: theme.spacing(0.25),
        }
    },
    
    // Divisor vertical entre grupos
    divider: {
        height: 24,
        margin: theme.spacing(0, 1),
        [theme.breakpoints.down('sm')]: {
            margin: theme.spacing(0, 0.5),
        }
    },
      // Botões de ação
    actionButton: {
        padding: theme.spacing(1),
        borderRadius: theme.spacing(1),
        transition: "all 0.2s ease",
        "&:hover": {
            backgroundColor: theme.palette.action.hover,
            transform: "scale(1.05)",
        },
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(0.75),
            minWidth: 40,
        }
    },
    
    // Estados dos ícones
    iconActive: {
        color: theme.palette.primary.main,
    },
    iconInactive: {
        color: theme.palette.text.disabled,
    },
    iconSuccess: {
        color: theme.palette.success.main,
    },
    iconWarning: {
        color: theme.palette.warning.main,
    },
    iconError: {
        color: theme.palette.error.main,
    },
    
    // Menu mobile
    mobileMenu: {
        [theme.breakpoints.up('md')]: {
            display: 'none',
        }
    },
    
    // Itens visíveis apenas no desktop
    desktopOnly: {
        [theme.breakpoints.down('sm')]: {
            display: 'none',
        }
    },
      // Tooltips customizados
    tooltip: {
        fontSize: 12,
        fontWeight: 500,
    },
    
    // Modal de resolução (estilo original)
    botoes: {
        padding: theme.spacing(2),
        gap: theme.spacing(2),
        justifyContent: "center",
    },
    actionButtons: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        gap: theme.spacing(1),
        marginLeft: "auto",
        padding: theme.spacing(1),
        backgroundColor: theme.palette.background.paper,
        borderRadius: theme.spacing(1),
        boxShadow: theme.shadows[1],
        flexWrap: "wrap",
        [theme.breakpoints.down('sm')]: {
            gap: theme.spacing(0.5),
            padding: theme.spacing(0.5),
        },
    },
    
    buttonGroup: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(0.5),
        padding: theme.spacing(0.5),
        borderRadius: theme.spacing(0.5),
        [theme.breakpoints.down('sm')]: {
            gap: theme.spacing(0.25),
            padding: theme.spacing(0.25),
        },
    },
    
    primaryButton: {
        minWidth: 'auto',
        padding: theme.spacing(1, 2),
        borderRadius: theme.spacing(3),
        textTransform: 'none',
        fontWeight: 600,
        transition: 'all 0.2s ease-in-out',
        '&:hover': {
            transform: 'translateY(-1px)',
            boxShadow: theme.shadows[4],
        },
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(0.5, 1),
            minWidth: 'auto',
        },
    },
    
    iconButton: {
        padding: theme.spacing(1),
        color: theme.palette.primary.main,
        borderRadius: theme.spacing(1),
        transition: 'all 0.2s ease-in-out',
        '&:hover': {
            backgroundColor: theme.palette.primary.light,
            color: theme.palette.primary.contrastText,
            transform: 'scale(1.05)',
        },
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(0.75),
        },
    },
    
    dangerButton: {
        color: theme.palette.error.main,
        '&:hover': {
            backgroundColor: theme.palette.error.light,
            color: theme.palette.error.contrastText,
        },
    },
    
    successButton: {
        color: theme.palette.success.main,
        '&:hover': {
            backgroundColor: theme.palette.success.light,
            color: theme.palette.success.contrastText,
        },
    },
    
    warningButton: {
        color: theme.palette.warning.main,
        '&:hover': {
            backgroundColor: theme.palette.warning.light,
            color: theme.palette.warning.contrastText,
        },
    },
    
    menuButton: {
        padding: theme.spacing(1),
        borderRadius: theme.spacing(1),
        color: theme.palette.text.secondary,
        '&:hover': {
            backgroundColor: theme.palette.action.hover,
            color: theme.palette.text.primary,
        },
    },
    
    divider: {
        height: 24,
        margin: theme.spacing(0, 1),
        backgroundColor: theme.palette.divider,
        [theme.breakpoints.down('sm')]: {
            height: 20,
            margin: theme.spacing(0, 0.5),
        },
    },
    
    switchContainer: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(1),
        padding: theme.spacing(0.5),
    },
    
    switchLabel: {
        fontSize: '0.875rem',
        color: theme.palette.text.secondary,
        [theme.breakpoints.down('sm')]: {
            display: 'none',
        },
    },
    
    modalActions: {
        display: "flex",
        gap: theme.spacing(2),
        padding: theme.spacing(2),
        justifyContent: "center",
        flexWrap: "wrap",
        [theme.breakpoints.down('sm')]: {
            gap: theme.spacing(1),
            padding: theme.spacing(1),
        },
    },
    
    modalButton: {
        minWidth: 140,
        padding: theme.spacing(1.5, 3),
        borderRadius: theme.spacing(3),
        textTransform: 'none',
        fontWeight: 600,
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
        [theme.breakpoints.down('sm')]: {
            minWidth: 120,
            padding: theme.spacing(1, 2),
        },
    },
    
    mobileHideText: {
        [theme.breakpoints.down('sm')]: {
            display: 'none',
        },
    },
}));

const SessionSchema = Yup.object().shape({
    ratingId: Yup.string().required("Avaliação obrigatória"),
});

const TicketActionButtonsCustom = ({ ticket
    // , showSelectMessageCheckbox,
    // selectedMessages,
    // forwardMessageModalOpen,
    // setForwardMessageModalOpen
}) => {
    const classes = useStyles();
    const theme = useTheme();
    const history = useHistory();
    
    // Responsividade
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isTablet = useMediaQuery(theme.breakpoints.down('md'));
    
    const [isMounted, setIsMounted] = useState(true);
    const [loading, setLoading] = useState(false);
    const { user } = useContext(AuthContext);
    const planAdvanced = Boolean(user?.company?.plan?.useKanbanAdvanced || user?.plan?.useKanbanAdvanced || user?.useKanbanAdvanced);
    const { setCurrentTicket, setTabOpen } = useContext(TicketsContext);
    const [open, setOpen] = React.useState(false);
    const formRef = React.useRef(null);
    const [confirmationOpen, setConfirmationOpen] = useState(false);
    const [transferTicketModalOpen, setTransferTicketModalOpen] = useState(false);
    const [scheduleModalOpen, setScheduleModalOpen] = useState(false);
    const [contactId, setContactId] = useState(null);
    const [acceptTicketWithouSelectQueueOpen, setAcceptTicketWithouSelectQueueOpen] = useState(false);    const [showTicketLogOpen, setShowTicketLogOpen] = useState(false);
    const [openTicketMessageDialog, setOpenTicketMessageDialog] = useState(false);
    // Guard against missing ticket.contact on first render
    const [disableBot, setDisableBot] = useState(!!(ticket?.contact?.disableBot));
    const [acceptAudioMessage, setAcceptAudio] = useState(!!(ticket?.contact?.acceptAudioMessage));
    const audioDisabled = acceptAudioMessage === false;

    const [showSchedules, setShowSchedules] = useState(false);
    const [enableIntegration, setEnableIntegration] = useState(ticket.useIntegration);

    const [openAlert, setOpenAlert] = useState(false);
    const [userTicketOpen, setUserTicketOpen] = useState("");
    const [queueTicketOpen, setQueueTicketOpen] = useState("");
    const [logTicket, setLogTicket] = useState([]);

    const { get: getSetting } = useCompanySettings()
    const { getPlanCompany } = usePlans();


    const [anchorEl, setAnchorEl] = useState(null);
    const [menuOpen, setMenuOpen] = useState(false);
    // Manual Ticket Creation feature
    const [manualTicketEnabled, setManualTicketEnabled] = useState(false);
    // Modal de detalhes do ticket oficial recém-criado
    const [detailsOpen, setDetailsOpen] = useState(false);
    const [detailsTicketId, setDetailsTicketId] = useState(null);
    const [createdTicketUuid, setCreatedTicketUuid] = useState(null);
    const [creatingTicket, setCreatingTicket] = useState(false);

    useEffect(() => {
        fetchData();

        // Cleanup function to set isMounted to false when the component unmounts
        return () => {
            setIsMounted(false);
        };
    }, []);

    // Reflect updates when ticket/contact data arrives later
    useEffect(() => {
        setDisableBot(!!(ticket?.contact?.disableBot));
        setAcceptAudio(!!(ticket?.contact?.acceptAudioMessage));
    }, [ticket?.contact?.id, ticket?.contact?.disableBot, ticket?.contact?.acceptAudioMessage]);


    const fetchData = async () => {
        const companyId = user.companyId;
        const planConfigs = await getPlanCompany(undefined, companyId);
        setShowSchedules(planConfigs.plan.useSchedules);
        setOpenTicketMessageDialog(false);
    // ticket.contact may not be immediately available
    setDisableBot(!!(ticket?.contact?.disableBot));

        setShowTicketLogOpen(false)
        // Check feature flag for manual ticket creation
        try {
            const setting = await getSetting({
                column: "manualTicketCreation"
            });
            setManualTicketEnabled(setting?.manualTicketCreation === "enabled");
        } catch (err) {
            setManualTicketEnabled(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }

    const handleClickOpen = async (e) => {
        const setting = await getSetting({
            "column": "requiredTag"
        });

        if (setting?.requiredTag === "enabled") {
            //verificar se tem uma tag   
            try {
                if (!ticket?.contact?.id) {
                    toast.warning(i18n.t("messagesList.header.buttons.requiredTag"));
                    return;
                }
                const contactTags = await api.get(`/contactTags/${ticket.contact.id}`);
                if (!contactTags.data.tags) {
                    toast.warning(i18n.t("messagesList.header.buttons.requiredTag"))
                } else {
                    setOpen(true);
                    // handleUpdateTicketStatus(e, "closed", user?.id);
                }
            } catch (err) {
                toastError(err);
            }
        } else {

            setOpen(true);
            // handleUpdateTicketStatus(e, "closed", user?.id);
        }
    };

    const handleClose = () => {
        formRef.current.resetForm();
        setOpen(false);
    };

    const handleCloseAlert = () => {
        setOpenAlert(false);
        setLoading(false);
    };
    const handleOpenAcceptTicketWithouSelectQueue = async () => {

        setAcceptTicketWithouSelectQueueOpen(true);

    };

    const handleMenu = event => {
        setAnchorEl(event.currentTarget);
        setMenuOpen(true);
    };

    const handleCloseMenu = () => {
        setAnchorEl(null);
        setMenuOpen(false);
    };

    const handleOpenTransferModal = (e) => {
        setTransferTicketModalOpen(true);
        if (typeof handleClose == "function") handleClose();
    };

    const handleOpenConfirmationModal = (e) => {
        setConfirmationOpen(true);
        if (typeof handleClose == "function") handleClose();
    };


    const handleCloseTicketWithoutFarewellMsg = async () => {
        setLoading(true);
        try {
            await api.put(`/tickets/${ticket.id}`, {
                status: "closed",
                userId: user?.id || null,
                sendFarewellMessage: false,
                amountUsedBotQueues: 0
            });

            setLoading(false);
            history.push("/tickets");
        } catch (err) {
            setLoading(false);
            toastError(err);
        }
    };

    const handleExportPDF = async () => {
        setOpenTicketMessageDialog(true);
        handleCloseMenu();
    }

    const handleEnableIntegration = async () => {
        setLoading(true);
        try {
            await api.put(`/tickets/${ticket.id}`, {
                useIntegration: !enableIntegration
            });
            setEnableIntegration(!enableIntegration)

            setLoading(false);
        } catch (err) {
            setLoading(false);
            toastError(err);
        }
    };

    const handleShowLogTicket = async () => {
        setShowTicketLogOpen(true);
    };

    // Encerrar atendimento: se for sessão, fechar (status=closed) com fluxos padrão (despedida/NPS); se oficial, apenas desatribuir.
    const handleEndAttendance = async () => {
        setLoading(true);
        try {
            if (!ticket.isOfficial) {
                await api.put(`/tickets/${ticket.id}`, {
                    status: "closed",
                    userId: user?.id || null,
                    amountUsedBotQueues: 0
                });
            } else {
                await api.put(`/tickets/${ticket.id}`, { userId: null });
            }
            setLoading(false);
            setOpen(false);
            toast.success(!ticket.isOfficial ? "Atendimento encerrado (sessão fechada)." : "Atendimento encerrado. Ticket permanece ativo.");
            history.push("/tickets");
        } catch (err) {
            setLoading(false);
            toastError(err);
        }
    };

    const handleContactToggleDisableBot = async () => {

        const id = ticket?.contact?.id;
        if (!id) {
            toast.warning("Contato indisponível para alternar bot agora");
            return;
        }


        try {
            const { data } = await api.put(`/contacts/toggleDisableBot/${id}`);
            if (ticket.contact) ticket.contact.disableBot = data.disableBot;
            setDisableBot(data.disableBot)

        } catch (err) {
            toastError(err);
        }
    };

    const handleContactToggleAcceptAudio = async () => {
        try {
            const id = ticket?.contact?.id;
            if (!id) {
                toast.warning("Contato indisponível para alternar áudio agora");
                return;
            }
            const contact = await api.put(`/contacts/toggleAcceptAudio/${id}`);
            setAcceptAudio(contact.data.acceptAudioMessage);
        } catch (err) {
            toastError(err);
        }
    };

    const handleCloseTransferTicketModal = () => {
        setTransferTicketModalOpen(false);
    };

    const handleDeleteTicket = async () => {
        try {
            await api.delete(`/tickets/${ticket.id}`);
            history.push("/tickets")
        } catch (err) {
            toastError(err);
        }
    };

    // Create Official Ticket from current session: abrir modal para criar somente ao salvar
    const handleOpenCreateOfficial = async () => {
        try {
            setCreatingTicket(true);
            // Abrir modal de detalhes em modo criação, com contato pré-definido e travado
            setDetailsTicketId(null);
            setCreatedTicketUuid(null);
            setDetailsOpen(true);
        } catch (err) {
            toastError(err);
        } finally {
            setCreatingTicket(false);
        }
    };


    const handleUpdateTicketStatus = async (e, status, userId) => {
        setLoading(true);
        try {
            await api.put(`/tickets/${ticket.id}`, {
                status: status,
                userId: userId || null,
            });

            let setting;

            try {
                setting = await getSetting({
                    "column": "sendGreetingAccepted"
                })
            } catch (err) {
                toastError(err);
            }

            if (setting?.sendGreetingAccepted === "enabled" && (!ticket.isGroup || ticket.whatsapp?.groupAsTicket === "enabled") && ticket.status === "pending") {
                // Saudação será gerada pelo backend
            }


            // if (isMounted.current) {
            setLoading(false);
            // }
            if (status === "open" || status === "group") {
                setCurrentTicket({ ...ticket, code: "#" + status });
                // handleSelectTicket(ticket);
                setTimeout(() => {
                    history.push('/tickets');
                }, 0);

                setTimeout(() => {
                    history.push(`/tickets/${ticket.uuid}`);
                    setTabOpen(status)
                }, 10);


            } else {
                setCurrentTicket({ id: null, code: null })
                history.push("/tickets");

            }
        } catch (err) {
            setLoading(false);
            toastError(err);
        }
    };

    const handleAcepptTicket = async (id) => {
        setLoading(true);
        try {
            const otherTicket = await api.put(`/tickets/${id}`, {
                status: ticket.isGroup ? "group" : "open",
                userId: user?.id,
            });
            if (otherTicket.data.id !== ticket.id) {
                if (otherTicket.data.userId !== user?.id) {
                    setOpenAlert(true)
                    setUserTicketOpen(otherTicket.data.user.name)
                    setQueueTicketOpen(otherTicket.data.queue.name)
                    setTabOpen(otherTicket.isGroup ? "group" : "open")
                } else {
                    setLoading(false);
                    // handleSelectTicket(otherTicket.data);
                    setTabOpen(otherTicket.isGroup ? "group" : "open")

                    history.push(`/tickets/${otherTicket.data.uuid}`);
                }
            } else {
                // if (isMounted.current) {
                setLoading(false);
                // }

                // handleSelectTicket(ticket);
                history.push('/tickets');
                setTimeout(() => {
                    history.push(`/tickets/${ticket.uuid}`);
                    setTabOpen(ticket.isGroup ? "group" : "open")
                }, 1000)
            }
        } catch (err) {
            setLoading(false);
            toastError(err);
        }
    };

    return (
        <>
            {openAlert && (
                <ShowTicketOpen
                    isOpen={openAlert}
                    handleClose={handleCloseAlert}
                    user={userTicketOpen}
                    queue={queueTicketOpen}
                />
            )}
            {acceptTicketWithouSelectQueueOpen && (
                <AcceptTicketWithouSelectQueue
                    modalOpen={acceptTicketWithouSelectQueueOpen}
                    onClose={(e) => setAcceptTicketWithouSelectQueueOpen(false)}
                    ticketId={ticket.id}
                    ticket={ticket}
                />
            )}
            {showTicketLogOpen && (
                <ShowTicketLogModal
                    isOpen={showTicketLogOpen}
                    handleClose={(e) => setShowTicketLogOpen(false)}
                    ticketId={ticket.id}
                />
            )}
            {openTicketMessageDialog && (
                <TicketMessagesDialog
                    open={openTicketMessageDialog}
                    handleClose={() => setOpenTicketMessageDialog(false)}
                    ticketId={ticket.id}
                />            )}
            
            {/* Modals */}
            {confirmationOpen && (
                <ConfirmationModal
                    title={`${i18n.t("ticketOptionsMenu.confirmationModal.title")} #${ticket.id}?`}
                    open={confirmationOpen}
                    onClose={setConfirmationOpen}
                    onConfirm={handleDeleteTicket}
                >
                    {i18n.t("ticketOptionsMenu.confirmationModal.message")}
                </ConfirmationModal>
            )}
            {transferTicketModalOpen && (
                <TransferTicketModalCustom
                    modalOpen={transferTicketModalOpen}
                    onClose={handleCloseTransferTicketModal}
                    ticketid={ticket.id}
                    ticket={ticket}
                />
            )}
            {/* Modal de Detalhes do Ticket (oficial) */}
            {detailsOpen && (
                <TicketDetailsModal
                    open={detailsOpen}
                    onClose={() => setDetailsOpen(false)}
                    ticketId={detailsTicketId}
                    // Quando abrimos para criar a partir da conversa, passamos o contato e travamos a seleção
                    initialContact={(!detailsTicketId && ticket?.contact) ? { id: ticket.contact.id, name: ticket.contact.name, number: ticket.contact.number } : null}
                    lockContact={!detailsTicketId}
                    onSaved={(createdUuid) => {
                        // Manter na conversa atual: não navegar para o ticket oficial recém-criado
                        setDetailsOpen(false);
                        if (createdUuid) {
                            try { toast.success("Ticket oficial criado."); } catch {}
                            // Sinaliza o header da conversa para atualizar os chips de "Tickets abertos"
                            try {
                                window.dispatchEvent(new CustomEvent('refresh-officials', { detail: { contactId: ticket?.contact?.id, sessionId: ticket?.id } }));
                            } catch {}
                        }
                    }}
                />
            )}
            <Box className={classes.actionBar}>
                {/* Botões de Status - Sempre visíveis primeiro */}
                {ticket.status === "closed" && !manualTicketEnabled && (
                    <Box className={classes.buttonGroup}>
                        <ButtonWithSpinner
                            loading={loading}
                            startIcon={<Replay />}
                            size="small"
                            onClick={e => ticket.queueId ? handleAcepptTicket(ticket.id) : handleOpenAcceptTicketWithouSelectQueue()}
                        >
                            {!isMobile && i18n.t("messagesList.header.buttons.reopen")}
                        </ButtonWithSpinner>
                    </Box>
                )}
                
                {ticket.status === "pending" && (
                    <Box className={classes.buttonGroup}>
                        <ButtonWithSpinner
                            loading={loading}
                            size="small"
                            variant="contained"
                            onClick={e => ticket.queueId ? handleUpdateTicketStatus(e, "open", user?.id) : handleOpenAcceptTicketWithouSelectQueue()}
                        >
                            {!isMobile && i18n.t("messagesList.header.buttons.accept")}
                        </ButtonWithSpinner>
                    </Box>
                )}                {/* Ações Principais - Desktop: Todos os ícones, Mobile: Menu */}
                {(ticket.status === "open" || ticket.status === "group") && (
                    <>                        {/* Desktop: Todos os Ícones na Ordem Original */}
                        {!isMobile && (
                            <Box className={classes.buttonGroup}>
                                                                {audioDisabled && (
                                                                    <Tooltip title="Áudio desativado para este contato" classes={{ tooltip: classes.tooltip }}>
                                                                        <Chip size="small" icon={<MicOff style={{ color: theme.palette.error.main }} />} label="Áudio off" />
                                                                    </Tooltip>
                                                                )}
                                {/* Ordem Original: Resolver → Retornar → Transferir → Integração → Logs → PDF → Bot → Áudio */}
                                
                                <Tooltip title={i18n.t("messagesList.header.buttons.resolve")} classes={{ tooltip: classes.tooltip }}>
                                    <IconButton className={classes.actionButton} onClick={handleClickOpen}>
                                        <HighlightOffIcon className={classes.iconError} />
                                    </IconButton>
                                </Tooltip>
                                
                                <Tooltip title={i18n.t("tickets.buttons.returnQueue")} classes={{ tooltip: classes.tooltip }}>
                                    <IconButton className={classes.actionButton} onClick={(e) => handleUpdateTicketStatus(e, "pending", null)}>
                                        <UndoIcon className={classes.iconWarning} />
                                    </IconButton>
                                </Tooltip>
                                
                                <Tooltip title={i18n.t("ticketOptionsMenu.transfer")} classes={{ tooltip: classes.tooltip }}>
                                    <IconButton className={classes.actionButton} onClick={handleOpenTransferModal}>
                                        <SwapHorizOutlined className={classes.iconActive} />
                                    </IconButton>
                                </Tooltip>

                {manualTicketEnabled && !planAdvanced && !ticket.isOfficial && (
                                    <ButtonWithSpinner
                    loading={creatingTicket}
                                        size="small"
                                        onClick={handleOpenCreateOfficial}
                                        style={{ marginLeft: 8 }}
                                    >
                                        {!isMobile && "Criar Ticket"}
                                    </ButtonWithSpinner>
                                )}
                                
                                <Divider orientation="vertical" className={classes.divider} />


                                <Tooltip title={enableIntegration ? i18n.t("messagesList.header.buttons.disableIntegration") : i18n.t("messagesList.header.buttons.enableIntegration")} classes={{ tooltip: classes.tooltip }}>
                                    <IconButton className={classes.actionButton} onClick={handleEnableIntegration}>
                                        <DeviceHubOutlined className={enableIntegration ? classes.iconSuccess : classes.iconInactive} />
                                    </IconButton>
                                </Tooltip>
                                
                                <Tooltip title={i18n.t("messagesList.header.buttons.logTicket")} classes={{ tooltip: classes.tooltip }}>
                                    <IconButton className={classes.actionButton} onClick={handleShowLogTicket}>
                                        <History className={classes.iconActive} />
                                    </IconButton>
                                </Tooltip>
                                
                                <Tooltip title={i18n.t("ticketsList.buttons.exportAsPDF")} classes={{ tooltip: classes.tooltip }}>
                                    <IconButton className={classes.actionButton} onClick={handleExportPDF}>
                                        <PictureAsPdf className={classes.iconActive} />
                                    </IconButton>
                                </Tooltip>
                                
                                <Tooltip title={disableBot ? "Bot desabilitado" : "Bot habilitado"} classes={{ tooltip: classes.tooltip }}>
                                    <IconButton className={classes.actionButton} onClick={handleContactToggleDisableBot}>
                                        <div style={{ fontSize: 20, filter: disableBot ? 'grayscale(100%)' : 'none' }}>🤖</div>
                                    </IconButton>
                                </Tooltip>                                <Tooltip title={acceptAudioMessage ? "Aceitar áudio do contato" : "Desativar áudio do contato"} classes={{ tooltip: classes.tooltip }}>
                                    <IconButton className={classes.actionButton} onClick={handleContactToggleAcceptAudio}>
                                        {acceptAudioMessage ? <VolumeUp className={classes.iconSuccess} /> : <VolumeOff className={classes.iconInactive} />}
                                    </IconButton>
                                </Tooltip>
                                
                                {/* Grupo 4: Ações Críticas */}
                                <Can
                                    role={user.profile}
                                    perform="ticket-options:deleteTicket"
                                    yes={() => (
                                        <>
                                            <Divider orientation="vertical" className={classes.divider} />
                                            <Tooltip title={i18n.t("tickets.buttons.deleteTicket")} classes={{ tooltip: classes.tooltip }}>
                                                <IconButton className={classes.actionButton} onClick={handleOpenConfirmationModal}>
                                                    <Delete className={classes.iconError} />
                                                </IconButton>
                                            </Tooltip>
                                        </>
                                    )}
                                />
                            </Box>
                        )}
                        
                        {/* Mobile: Ações Essenciais + Menu */}
                        {isMobile && (
                            <Box className={classes.buttonGroup}>
                                {/* Resolver */}
                                <Tooltip title={i18n.t("messagesList.header.buttons.resolve")}>
                                    <IconButton className={classes.actionButton} onClick={handleClickOpen}>
                                        <HighlightOffIcon className={classes.iconError} />
                                    </IconButton>
                                </Tooltip>

                                {/* Devolver à fila */}
                                <Tooltip title={i18n.t("tickets.buttons.returnQueue")}>
                                    <IconButton className={classes.actionButton} onClick={(e) => handleUpdateTicketStatus(e, "pending", null)}>
                                        <UndoIcon className={classes.iconWarning} />
                                    </IconButton>
                                </Tooltip>

                                {/* Transferir */}
                                <Tooltip title={i18n.t("ticketOptionsMenu.transfer")}>
                                    <IconButton className={classes.actionButton} onClick={handleOpenTransferModal}>
                                        <SwapHorizOutlined className={classes.iconActive} />
                                    </IconButton>
                                </Tooltip>

                                {/* Bot on/off */}
                                <Tooltip title={disableBot ? "Bot desabilitado" : "Bot habilitado"}>
                                    <IconButton className={classes.actionButton} onClick={handleContactToggleDisableBot}>
                                        <div style={{ fontSize: 20, filter: disableBot ? 'grayscale(100%)' : 'none' }}>🤖</div>
                                    </IconButton>
                                </Tooltip>
                            </Box>
                        )}
                    </>                )}

                {/* Menu de 3 pontos - Apenas no mobile */}
                {isMobile && (
                    <>
                        <IconButton
                            aria-label="more options"
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            onClick={handleMenu}
                            className={classes.actionButton}
                        >
                            <MoreVert />
                        </IconButton>
                        
                        <Menu
                            id="menu-appbar"
                            anchorEl={anchorEl}
                            getContentAnchorEl={null}
                            anchorOrigin={{
                                vertical: "bottom",
                                horizontal: "right",
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: "top",
                                horizontal: "right",
                            }}
                            open={menuOpen}
                            onClose={handleCloseMenu}
                            PaperProps={{
                                style: {
                                    maxWidth: '95vw',
                                    width: '320px',
                                    overflowX: 'hidden',
                                }
                            }}
                        >
                            {/* Removido: Devolver à fila (agora fora do menu no mobile) */}
                            <MenuItem onClick={() => { handleEnableIntegration(); handleCloseMenu(); }}>
                                <DeviceHubOutlined style={{ marginRight: 8, color: enableIntegration ? theme.palette.success.main : theme.palette.text.secondary }} />
                                {enableIntegration ? "Desativar integração" : "Ativar integração"}
                            </MenuItem>
                            <MenuItem onClick={() => { handleShowLogTicket(); handleCloseMenu(); }}>
                                <History style={{ marginRight: 8 }} />
                                {i18n.t("messagesList.header.buttons.logTicket")}
                            </MenuItem>
                            <MenuItem onClick={() => { handleExportPDF(); handleCloseMenu(); }}>
                                <PictureAsPdf style={{ marginRight: 8 }} />
                                {i18n.t("ticketsList.buttons.exportAsPDF")}
                            </MenuItem>
                            {manualTicketEnabled && !planAdvanced && !ticket.isOfficial && (
                                <MenuItem onClick={() => { handleOpenCreateOfficial(); handleCloseMenu(); }}>
                                    <VerifiedUser style={{ marginRight: 8 }} />
                                    {"Criar Ticket"}
                                </MenuItem>
                            )}
                            {/* Removido: Bot on/off (agora fora do menu no mobile) */}
                            <MenuItem onClick={() => { handleContactToggleAcceptAudio(); handleCloseMenu(); }}>
                                {acceptAudioMessage ? <VolumeUp style={{ marginRight: 8, color: theme.palette.success.main }} /> : <VolumeOff style={{ marginRight: 8, color: theme.palette.text.disabled }} />}
                                {acceptAudioMessage ? "Desativar áudio" : "Ativar áudio"}
                            </MenuItem>
                            <Can
                                role={user.profile}
                                perform="ticket-options:deleteTicket"
                                yes={() => ([
                                        <Divider key="divider-delete" />,
                                        <MenuItem key="menu-delete" onClick={() => { handleOpenConfirmationModal(); handleCloseMenu(); }}>
                                            <Delete style={{ marginRight: 8, color: theme.palette.error.main }} />
                                            {i18n.t("tickets.buttons.deleteTicket")}
                                        </MenuItem>
                                    ])}
                            />
                        </Menu>
                    </>
                )}
            </Box>
            <>
                <Formik
                    enableReinitialize={true}
                    validationSchema={SessionSchema}
                    innerRef={formRef}
                    onSubmit={(values, actions) => {
                        setTimeout(() => {
                            actions.setSubmitting(false);
                            actions.resetForm();
                        }, 400);
                    }}
                >
                    {({ values, touched, errors, isSubmitting, setFieldValue, resetForm }) => (
                        <Dialog
                            open={open}
                            onClose={handleClose}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >                            <Form>
                                <DialogActions className={classes.botoes}>
                                    <Button
                                        onClick={e => handleCloseTicketWithoutFarewellMsg()}
                                        style={{ background: "#d1312e", color: "white", fontSize: "14px" }}
                                    >
                                        <Error style={{ color: "white", fontSize: "30px" }} />
                                        {i18n.t("messagesList.header.dialogRatingWithoutFarewellMsg")}
                                    </Button>

                                    <Button
                                        onClick={e => handleUpdateTicketStatus(e, "closed", user?.id, ticket?.queue?.id)}
                                        style={{ background: "#5ebf49", color: "white", fontSize: "14px" }}
                                    >
                                        <VerifiedUser style={{ color: "white", fontSize: "30px" }} />
                                        {i18n.t("messagesList.header.dialogRatingCancel")}
                                    </Button>
                                </DialogActions>
                            </Form>
                        </Dialog>
                    )}
                </Formik>
            </>
        </>
    );
};

export default TicketActionButtonsCustom;
